import React from 'react';
import {
  Box, Button, Snackbar as MuiSnackbar, Typography,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { selectSnackbar, setSnackbar } from '../../../state/snackbar/snackbarSlice';
import SnackbarIcon from '../../atoms/SnackbarIcon/SnackbarIcon';

function Snackbar() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const {
    open, duration, message, action, type,
  } = useSelector(selectSnackbar);

  const handleClose = (e, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    dispatch(setSnackbar({}));
  };

  if (!message) {
    return null;
  }

  return (
    <MuiSnackbar
      open={open}
      autoHideDuration={duration}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
      message={(
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {type && <SnackbarIcon type={type} />}
          <Typography>{message}</Typography>
        </Box>
      )}
      action={action ? (
        <Button color="inherit" size="small" onClick={() => navigate(action.link)} sx={{ mr: 2 }}>
          {action.label}
        </Button>
      ) : null}
    />
  );
}

export default Snackbar;
